<h3>{{ 'irrigation.tableTitle' | translate }}</h3>

@for (cropField of cropFieldsWithIrrigations(); track cropField.id) {
  <div class="spacing--margin-bottom">
    <h4>{{ cropField.name }}</h4>
    <mat-table class="table-wrapper" [dataSource]="cropField.irrigations" data-test="spray-applications-table">
      <ng-container matColumnDef="start">
        <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
          <span>{{ 'irrigation.startDate' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let irrigation" class="flex__child flex__child-4" data-test="irrigation-start">
          <span>
            {{ irrigation.startedOn | date: 'shortDate' : undefined : locale() }}
            {{ irrigation.startedOn | date: 'HH:mm' : 'UTC' : locale() }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="end">
        <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
          <span>{{ 'irrigation.endDate' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let irrigation" class="flex__child flex__child-4" data-test="irrigation-end">
          <span class="time-cell-content">
            <span>
              {{ irrigation.endedOn | date: 'shortDate' : undefined : locale() }}
              {{ irrigation.endedOn | date: 'HH:mm' : 'UTC' : locale() }}
            </span>
            @if (isZeroDurationIrrigation(irrigation)) {
              <mat-icon
                class="zero-duration-warning-icon"
                [matTooltip]="'irrigation.zeroDurationWarning' | translate"
                [attr.aria-label]="'irrigation.zeroDurationWarning' | translate"
                matTooltipPosition="above"
                data-test="zero-duration-warning-icon"
              >
                notifications
              </mat-icon>
            }
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
          <span>{{ 'irrigation.type' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let irrigation" class="flex__child flex__child-4">
          <span>{{ irrigation.type | irrigationType | translate }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
          <span>{{ 'report.amount' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let irrigation" class="flex__child flex__child-4">
          <span>{{ irrigation.amountInMillimeters }} mm</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex" />
        <mat-cell *matCellDef="let irrigation" class="flex__child flex__child-4">
          <button
            mat-icon-button
            (click)="onDeleteIrrigation(cropField.id, irrigation)"
            [attr.aria-label]="'actions.delete' | translate"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns()" />
      <mat-row *matRowDef="let _row; columns: displayedColumns()" />
    </mat-table>
  </div>
}
